import useSWR from 'swr'
import { useToken } from "@app/hooks";
import API from "../../../utils/api";
import { USER_KYC_LIST } from '@app/constants/APIKEYS.tsx';


const M_KEY = '/kyc/status'

const fetchKey = ( ) =>
  `${M_KEY}`;

export function useKYCStatus() {
  const {data: token} = useToken();

  const KEY = fetchKey();

  const fetcher = () => fetchAPI(KEY, token);
  const {data, mutate} = useSWR(token ? `${KEY}` : null, fetcher,
    {
      revalidateOnFocus: true,
      // refreshInterval: 60000,
      // revalidateOnReconnect: true,
    });

  return {KYCStatus: data?.list, KYCStatusMutate: mutate};
}

async function fetchAPI(KEY: string, token: any) {
  try {
    const response = await API.get(`${KEY}`, token + '', {});
		// console.log('P2P Trades response', response);
    return {list: response?.result, total: response?.result?.totalCount};
  } catch (error) {
    console.error('Failed to fetch KYC Status ===> ', error);
    return {list: [], total: 0};
  }
}